import Record from 'Types/Record';
import Address from 'Types/address';
import { DateTime } from 'luxon';

export default Record(
  {
    cardToken: '',
    // organization: '',
    address: Address(),
    brand: undefined,
    expMonth: undefined,
    expYear: undefined,
    last4: undefined,
    cost: undefined,
    currency: undefined,
    planAmountSessions: undefined,
    planAmountRuns: undefined,
    nextBillingDate: undefined,
  },
  {
    methods: {
      validate() {
        return true;
      },
      toData() {
        const js = this.toJS();
        const address = this.address.toJS();
        delete address.key;
        delete js.key;

        js.address = address;
        return js;
      },
    },
    fromJS: ({ address, nextBillingDate, ...rest }) => ({
      ...rest,
      address: Address(address),
      nextBillingDate: nextBillingDate
        ? DateTime.fromMillis(nextBillingDate)
        : undefined,
    }),
  },
);
